var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"placeholder weather__temperature"},[_c('b-skeleton',{attrs:{"height":"20","width":"30"}}),_c('b-skeleton',{attrs:{"height":"10","width":"100%"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }